/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum CanvasOpIOS {
  GS_LINE_WIDTH = 0,
  GS_LINE_CAP = 1,
  GS_LINE_JOIN = 2,
  GS_MITER_LIMIT = 3,
  GS_DASH_PATTERN = 4,
  GS_RENDERING_INTENT = 5,
  GS_FLATNESS = 6,
  GS_DICT = 7,
  GS_DICT_ALPHA_STROKING = 8,
  GS_DICT_ALPHA_NONSTROKING = 9,
  GS_SAVE = 10,
  GS_RESTORE = 11,
  GS_CONCAT_MATRIX = 12,
  PATH_MOVE_TO = 13,
  PATH_LINE_TO = 14,
  PATH_CURVE_TO = 15,
  PATH_CURVE_TO23 = 16,
  PATH_CURVE_TO13 = 17,
  PATH_CLOSE = 18,
  PATH_RECT = 19,
  PATH_STROKE = 20,
  PATH_CLOSE_STROKE = 21,
  PATH_FILL_NONZERO = 22,
  PATH_FILL_EVEN_ODD = 23,
  PATH_FILL_STROKE_NONZERO = 24,
  PATH_FILL_STROKE_EVEN_ODD = 25,
  PATH_CLOSE_FILL_STROKE_NONZERO = 26,
  PATH_CLOSE_FILL_STROKE_EVEN_ODD = 27,
  PATH_END = 28,
  PATH_CLIP_NONZERO = 29,
  PATH_CLIP_EVEN_ODD = 30,
  TEXT_BEGIN_OBJECT = 31,
  TEXT_END_OBJECT = 32,
  TEXT_CHAR_SPACING = 33,
  TEXT_WORD_SPACING = 34,
  TEXT_H_SCALE = 35,
  TEXT_LEADING = 36,
  TEXT_FONT_SIZE = 37,
  TEXT_RENDER = 38,
  TEXT_RISE = 39,
  TEXT_NEXT_LINE = 40,
  TEXT_NEXT_LINE_LEADING = 41,
  TEXT_MATRIX = 42,
  TEXT_NEXT_LINE_CURRENT_LEADING = 43,
  TEXT_SHOW = 44,
  PAINT_SHADING = 45,
  COLOR_SET_STROKING = 46,
  COLOR_SET_NONSTROKING = 47,
  DRAW_CHILD = 48,
  DRAW_IMAGE = 49,
  DRAW_IMAGE_VIEW = 50,
  DRAW_BORDER = 51,
  DRAW_BACKGROUND_DEPRECATED = 52,
  DRAW_KEYBOARD = 53,
  VISUAL_EFFECT_BLUR = 54,
  VISUAL_EFFECT_VIBRANCY = 55,
  RESET_ALL = 32767,
}
